import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import { VNode } from 'vue'

import { widgetList } from '../utils/consts'
import { FormFieldDto } from '@/service-proxies/app-v2/dnc.service-proxies'
import { Pair } from './CreateForm'

@Component
export default class EditForm extends Vue {
  @Prop() record: FormFieldDto
  @Ref() readonly dForm: any
  schema = {}
  public visible = false
  public pair: Pair = { label: '', value: '' }
  public pairs: any = []
  public isSelect = false

  @Watch('record', { immediate: true })
  onRecordChange(val: FormFieldDto) {
    this.schema = {
      properties: {
        code: {
          title: this.$t('page_resource_pool_field'),
          default: val.code,
          readOnly: true
        },
        title: {
          title: this.$t('page_resource_pool_display_name'),
          default: val.title
        },
        widget: {
          title: this.$t('widget'),
          default: val.widget,
          ui: {
            widget: 'select'
          },
          enum: widgetList(this),
          readOnly: true
        },
        isEnabled: {
          title: this.$t('page_resource_pool_show'),
          default: val.isEnabled,
          ui: {
            widget: 'switch'
          },
          hidden: val.isSystem
        },
        isRequired: {
          title: this.$t('page_resource_pool_required'),
          default: val.isRequired,
          ui: {
            widget: 'switch'
          },
          hidden: val.isSystem
        },
        sort: {
          title: this.$t('page_resource_pool_sort'),
          default: val.sort || 0,
          ui: {
            widget: 'input-number'
          }
        }
      },
      required: ['code', 'title', 'widget']
    }
    this.isSelect = val.widget === 'SELECT'
    if (val.dataSource) {
      this.pairs = [...val.dataSource]
    }
  }

  handleCreate() {
    const isExist = !!this.pairs.find(item => item.label === this.pair.label || item.value === this.pair.value)
    if (isExist) {
      this.$message.info(this.$t('page_resource_pool_repeat_add'))
    } else {
      this.pairs = [...this.pairs, this.pair]
      this.visible = false
      this.pair = { label: '', value: '' }
    }
  }

  handleDelete(index) {
    this.pairs.splice(index, 1)
  }

  render(): VNode {
    return (
      <div>
        <d-form schema={this.schema} ref="dForm" />
        {this.isSelect ? (
          <a-button onClick={() => (this.visible = true)}>{this.$t('page_resource_pool_add_option')}</a-button>
        ) : null}
        {this.pairs.map((pair, index) => (
          <div>
            label: {pair.label} - value: {pair.value}
            <a-icon
              type="delete"
              style="color: #F56C6C; padding-left: 16px;"
              onClick={() => this.handleDelete(index)}
            />
          </div>
        ))}
        <a-modal
          title={this.$t('page_resource_pool_create')}
          v-model={this.visible}
          onOk={this.handleCreate}
          okText={this.$t('submit')}
          cancelText={this.$t('cancel')}
          destroyOnClose={true}
          maskClosable={false}
        >
          <a-form-item label="label">
            <a-input v-model={this.pair.label} placeholder="请输入label"/>
          </a-form-item>
          <a-form-item label="value">
            <a-input v-model={this.pair.value} placeholder="请输入value"/>
          </a-form-item>
        </a-modal>
      </div>
    )
  }
}
